import { IStatsDesktopResponse } from '../repositories/newbuilding-card/entities/stats/StatsDesktopResponse';
import { IRoomStatsResponse_desktop_fichering as IRoomStatsResponse } from '../repositories/newbuilding-card/entities/stats/RoomStatsResponse';
import { ILayoutRoom } from '../repositories/newbuilding-card/entities/stats/LayoutRoom';

const mapLayoutRoom = (layout: ILayoutRoom): ILayoutRoom => ({
  finishDate: layout.finishDate,
  gaLabel: layout.gaLabel,
  houseName: layout.houseName,
  layoutImageUrl: layout.layoutImageUrl ?? undefined,
  offerId: layout.offerId,
  offerUrl: layout.offerUrl,
  price: layout.price ?? undefined,
  priceDisplay: layout.priceDisplay,
  roomCount: layout.roomCount,
  totalArea: layout.totalArea,
});

const mapRoomStatsResponse = (room: IRoomStatsResponse): IRoomStatsResponse => ({
  fromDeveloperPropsCount: room.fromDeveloperPropsCount,
  fromDeveloperPropsCountDisplay: room.fromDeveloperPropsCountDisplay,
  layouts: room.layouts.map(mapLayoutRoom),
  offersUrl: room.offersUrl,
  price2Range: room.price2Range,
  roomType: room.roomType,
  roomTypeDisplay: room.roomTypeDisplay,
  totalAreaMinDisplay: room.totalAreaMinDisplay,
});

export const mapStatsDesktopResponse = (
  stats: IStatsDesktopResponse | null | undefined,
): IStatsDesktopResponse | null => {
  if (!stats) {
    return null;
  }

  return {
    fromAgentsPropsCountDisplay: stats.fromAgentsPropsCountDisplay,
    fromAgentsPropsCountUrl: stats.fromAgentsPropsCountUrl,
    fromDeveloperMaxPrice: stats.fromDeveloperMaxPrice ?? undefined,
    fromDeveloperMinPrice: stats.fromDeveloperMinPrice ?? undefined,
    fromDeveloperPropsCountDisplay: stats.fromDeveloperPropsCountDisplay,
    fromDeveloperPropsCountUrl: stats.fromDeveloperPropsCountUrl,
    fromDeveloperRooms: stats.fromDeveloperRooms.map(mapRoomStatsResponse),
    propsCountDisplay: stats.propsCountDisplay,
    propsCountUrl: stats.propsCountUrl,
  };
};
